import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import AuthLayout from '../components/AuthLayout';
import Seo from '../components/Seo';
import Icon from '../components/Icon';

export default function Login() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isPublisher, setIsPublisher] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setIsPublisher(false);
    setBusy(true);
    try {
      await login(email, password);
      navigate(location.state?.from || '/dashboard', { replace: true });
    } catch (err) {
      if (err.code === 'use_publisher_login') {
        setIsPublisher(true);
        setError(t('auth.is_publisher'));
      } else {
        setError(t([`auth.err_${err.code}`, 'auth.err_generic']));
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout>
      <Seo title={t('auth.login_title')} noindex />
      <div className="auth-head">
        <h1>{t('auth.login_title')}</h1>
        <p className="sub">{t('auth.login_sub')}</p>
      </div>

      {error && (
        <div className="form-error">
          <Icon name="alert-triangle" size={15} style={{ marginTop: 1, flexShrink: 0 }} />
          {error}
        </div>
      )}

      {isPublisher && (
        <Link to="/yayinci/giris" className="btn btn-block" style={{ marginBottom: 'var(--sp-4)' }}>
          {t('auth.publisher_link')} <Icon name="arrow" size={14} />
        </Link>
      )}

      <form onSubmit={submit} noValidate>
        <div className="field">
          <label htmlFor="email">{t('common.email')}</label>
          <div className="control">
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" placeholder="siz@sunucunuz.com" />
          </div>
        </div>
        <div className="field">
          <label htmlFor="password">{t('common.password')}</label>
          <div className="control">
            <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" placeholder="••••••••" />
          </div>
        </div>
        <button className="btn btn-block" disabled={busy}>
          {busy ? `${t('common.loading')}…` : t('auth.login_action')}
        </button>
      </form>

      <div className="auth-alt">
        {t('auth.no_account')} <Link to="/register">{t('auth.register_action')}</Link>
      </div>
      <div className="auth-alt" style={{ marginTop: 4 }}>
        {t('auth.publisher_hint')} <Link to="/yayinci/giris">{t('auth.publisher_link')}</Link>
      </div>
    </AuthLayout>
  );
}
